import * as React from 'react';
import { observer } from 'mobx-react';
import ReportItem from './ReportItem';
import { ReportResource } from '../../ReportsStore/Types';

interface Props {
  reports: ReportResource[];
}

const ReportItems: React.FC<Props> = ({ reports }) => {
  return (
    <div className="flex flex-wrap flex-start gap-5 lg:px-4">
      {reports.map((r) => (
        <ReportItem reportResource={r} key={r.payload.id} />
      ))}
    </div>
  );
};

export default observer(ReportItems);
